import React from 'react'
import styled from 'styled-components'

const Loader = ({ small, white }) => (
    <Container small={small} white={white}>
        <LoaderWrapper small={small} white={white}>
            <div />
            <div />
            <div />
            <div />
            <div />
        </LoaderWrapper>
        <h2>Loading</h2>
    </Container>
)

export default Loader

const Container = styled.div`
    ${({ small }) =>
        small
            ? `
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    `
            : `
    width: 100%;
    height: 95vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`}
    h2 {
        font-size: ${({ small }) => (small ? 15 : 20)}px;
        color: ${({ white }) => (white ? '#fff' : '#000')};
    }
`

const LoaderWrapper = styled.div`
    position: relative;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    display: block;
    font-size: 0;
    box-sizing: border-box;
    color: #333;
    height: ${({ small }) => (small ? 30 : 64)}px;
    width: ${({ small }) => (small ? 40 : 80)}px;

    & > div {
        width: ${({ small }) => (small ? 4 : 8)}px;
        height: ${({ small }) => (small ? 30 : 64)}px;
        margin: ${({ small }) => (small ? 2 : 4)}px;
        margin-top: 0;
        margin-bottom: 0;
        position: relative;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        float: none;
        background-color: ${({ white }) => (white ? '#fff' : '#000')};
        border: 0 solid ${({ white }) => (white ? '#fff' : '#000')};
        border-radius: 0;
        -webkit-animation: line-scale-pulse-out 0.9s infinite
            cubic-bezier(0.85, 0.25, 0.37, 0.85);
        -moz-animation: line-scale-pulse-out 0.9s infinite
            cubic-bezier(0.85, 0.25, 0.37, 0.85);
        -o-animation: line-scale-pulse-out 0.9s infinite
            cubic-bezier(0.85, 0.25, 0.37, 0.85);
        animation: line-scale-pulse-out 0.9s infinite
            cubic-bezier(0.85, 0.25, 0.37, 0.85);
    }

    & > div:nth-child(3) {
        -webkit-animation-delay: -0.9s;
        -moz-animation-delay: -0.9s;
        -o-animation-delay: -0.9s;
        animation-delay: -0.9s;
    }
    & > div:nth-child(2),
    & > div:nth-child(4) {
        -webkit-animation-delay: -0.7s;
        -moz-animation-delay: -0.7s;
        -o-animation-delay: -0.7s;
        animation-delay: -0.7s;
    }
    & > div:nth-child(1),
    & > div:nth-child(5) {
        -webkit-animation-delay: -0.5s;
        -moz-animation-delay: -0.5s;
        -o-animation-delay: -0.5s;
        animation-delay: -0.5s;
    }

    * Animation */ @-webkit-keyframes line-scale-pulse-out {
        0% {
            -webkit-transform: scaley(1);
            transform: scaley(1);
        }
        50% {
            -webkit-transform: scaley(0.3);
            transform: scaley(0.3);
        }
        100% {
            -webkit-transform: scaley(1);
            transform: scaley(1);
        }
    }
    @-moz-keyframes line-scale-pulse-out {
        0% {
            -moz-transform: scaley(1);
            transform: scaley(1);
        }
        50% {
            -moz-transform: scaley(0.3);
            transform: scaley(0.3);
        }
        100% {
            -moz-transform: scaley(1);
            transform: scaley(1);
        }
    }
    @-o-keyframes line-scale-pulse-out {
        0% {
            -o-transform: scaley(1);
            transform: scaley(1);
        }
        50% {
            -o-transform: scaley(0.3);
            transform: scaley(0.3);
        }
        100% {
            -o-transform: scaley(1);
            transform: scaley(1);
        }
    }
    @keyframes line-scale-pulse-out {
        0% {
            -webkit-transform: scaley(1);
            -moz-transform: scaley(1);
            -o-transform: scaley(1);
            transform: scaley(1);
        }
        50% {
            -webkit-transform: scaley(0.3);
            -moz-transform: scaley(0.3);
            -o-transform: scaley(0.3);
            transform: scaley(0.3);
        }
        100% {
            -webkit-transform: scaley(1);
            -moz-transform: scaley(1);
            -o-transform: scaley(1);
            transform: scaley(1);
        }
    }
`
